import Layout from '../components/layout/Layout';
import SingleProduct from '../components/product/Single';

const Product = () => {
    return (
        <Layout>
            <SingleProduct />
        </Layout>
    );
}

export default Product;
